/* eslint-disable react/jsx-no-undef */
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import {
  IonApp,
  IonButton,
  IonContent,
  IonModal,
  IonRouterOutlet,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
/* Theme variables */
import "./theme/variables.css";
import "./Css/global.css?v=1";
import SuccessFailed from "./pages/success-and-failed";
import Login from "./pages/Authentication/login";
import Code from "./pages/code";
import Home from "./pages/Home";
import UserProfile from "./pages/user-profile";
import CreateNewPatient from "./pages/create-new-patient-2";
import PatientPage from "./pages/patient-page";
import VisitSummary from "./pages/visit-summary";
import EndSession from "./pages/end-session";
import NetworkError from "./pages/network-error";
import { useEffect, useRef, useState } from "react";
import { ActionType, ApplicationLookup } from "./models/Enums";

import SitStandAssessmentPage from "./pages/sitstand-assessment";
import AssessmentPage from "./pages/assessment-page";
import ForgotPassword from "./pages/Authentication/forgot-password";
import PasswordReset from "./pages/Authentication/password-reset";
import CreateNewLookup from "./components/modals/create-new-lookup";
import React from "react";
import SignupEmail from "./pages/Authentication/signup-email";
import SignupCode from "./pages/Authentication/signup-code";
import Signup from "./pages/Authentication/signup";
import ReportPage from "./pages/report-page";
import AssessmentNotes from "./pages/assessment-notes";
import SelectAnAssessment from "./pages/select-an-assessment";

import { useIdleTimer } from "react-idle-timer";
import { LogOut, GenerateJsonToken } from "./services/AuthServices";
import GaitAssessmentInfo from "./pages/gait-assessment-info";
import PhoneAudioCheck from "./pages/phone-audio-check";
import EquipmentNeeded from "./pages/equipment-needed";
import PhoneHeightRequirement from "./pages/phone-height-requiremnt";
import AngleAdjustment from "./pages/angle-adjustment";
import { isShowToast, networkConnectionStatus } from "./data/atoms";
import SelectSectionCustom from "./components/SelectSectionCustom";
import PatientAssessmentSummary from "./pages/patient-assessment-summary";
import TagsName from "./components/TagsName";
import PaperErrorPopup from "./components/modals/paper-error-popup";
import LoaderModalComponent from "./components/modals/LoaderModal";
import PaperPlacementModal from "./components/modals/PaperPlacementModal";
import EditUserProfile from "./pages/edit-user-profile";
import { getMobileUIVersion } from "./utils/api-interceptor";
import { closeApp } from "./movenet";
import AssessmentDescription from "./components/modals/assessment-description";
import ErrorTopToaster from "./components/ErrorTopToaster";
import { useRecoilState } from "recoil";
import CreateEditPatient from "./pages/create-edit-patient";
import { load_DL_models } from "./movenet";
import Loader from "./components/LoaderComponent";
import SelectAssessmentType from "./pages/select-assessment-type";
import AssessmentsList from "./pages/assessments-list";
import AssessmentInfoTable from "./pages/assessment-info-table";
import PatientProfile from "./pages/patient-profile";
import SignupPassword from "./pages/Authentication/signup-password";
import { GetOSId } from "./utils/mobile-bridge";
import { config } from "./vision-algo/env_config";
import About from "./pages/about-page";
import TermsOfServices from "./pages/terms-of-services";
import PrivacyPolicy from "./pages/privacy-policy";
import FullVisitSummary from "./pages/full-visit-summary";
import DuplicateExercises from "./pages/DuplicateExercises";
import ReviewExercises from "./pages/ReviewExercises";
import AssignExercise from "./pages/assign-exercise";
import SendExercisePlan from "./pages/send-exercise-plan";
import { initializePendo } from "./utils/pendo";
import { ASSESSMENT_STATUSES, DL_MODELS } from "./movenet/params";
import { SentryLogging } from "./vision-algo/sending_sentry_logs";

setupIonicReact({
  swipeBackEnabled: false,
});

const App: React.FC = () => {
  let history = useHistory();

  //For auto-logout after 60 seconds
  // const myTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [myTimeout, setmyTimeout] = useState(setTimeout(() => {}));

  const [showToast, setShowToast] = useRecoilState(isShowToast);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [isServerError, setIsServerError] = useState(false);
  const [loadingDLModel, setLoadingDLModel] = useState(false);

  // Track last activity time
  // const lastActivityRef = useRef<number>(Date.now());

  // Check interval ref
  // const checkIntervalRef = useRef<NodeJS.Timeout | null>(null);

  // useEffect(() => {
  //   checkIntervalRef.current = setInterval(() => {
  //     console.log("Checking after every 5 minutes");

  //     const currentTime = Date.now();
  //     const idleTime = currentTime - lastActivityRef.current;

  //     console.log("Idle time:", idleTime);

  //     let isLogin;
  //     const token = localStorage.getItem("TokenID");
  //     if (token == null || token == undefined) {
  //       isLogin = false;
  //     } else {
  //       isLogin = true;
  //     }

  //     if (isLogin) {
  //       generateJsonToken();
  //     }
  //   }, 290000);

  //   // Cleanup on unmount
  //   return () => {
  //     if (checkIntervalRef.current) {
  //       clearInterval(checkIntervalRef.current);
  //       checkIntervalRef.current = null;
  //     }
  //   };
  // }, []);

  // async function generateJsonToken() {
  //   if (!navigator.onLine) {
  //     setShowNetWorkRecoil({ isShown: true });
  //     return;
  //   }

  //   const req = {
  //     UserName: localStorage.getItem("Username")!,
  //     EncryptedServerId: localStorage.getItem("EncryptedServerId")!,
  //     Token: localStorage.getItem("TokenID")!,
  //   };

  //   try {
  //     await GenerateJsonToken(req)
  //       .then(async function (response: any) {
  //         if (response!.data.isResponseSuccessful) {
  //           localStorage.setItem("TokenID", response!.data.token);
  //         } else {
  //           history.push("/confirmation", {
  //             actionType: ActionType.FailureAPIResponse,
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         history.push("/confirmation", {
  //           actionType: ActionType.FailureAPIResponse,
  //         });
  //       });
  //   } catch (error) {
  //     history.push("/confirmation", {
  //       actionType: ActionType.FailureAPIResponse,
  //     });
  //     console.error(error);
  //   }
  // }

  let Window = window as any;

  if (!config.console_log) {
    window.console.log = function () {};
  }

  Window["AngleAdjustmentReference"] = {
    component: this,
    UpdateSliderOnMovement: UpdateSliderOnMovement,
  };

  Window["ApplicationStatus"] = {
    component: this,
    GetAppStatus: GetAppStatus,
  };

  async function GetAppStatus(status: string) {
    if (
      (window.location.href === window.location.origin + "/assessment" &&
        status === "background") ||
      status === "inactive"
    ) {
      ASSESSMENT_STATUSES.sentry_message =
        ASSESSMENT_STATUSES.sentry_message +
        "\n" +
        new Date().toISOString() +
        `: Application Status : ${status} ( Application is no longer active. )`;

      SentryLogging();
    }
  }

  function UpdateSliderOnMovement(yaxis: number, xaxis: number) {
    yaxis = Number(yaxis);
    if (window.location.href == window.location.origin + "/angle-adjustment") {
      try {
        Window["AngleAdjustmentPageReference"].UpdateSliderOnMovement(yaxis);
      } catch (e: any) {
        if (GetOSId() === ApplicationLookup.iOS) {
          console.log("UpdateSliderOnMovement error");

          return "";
        }
      }
    } else if (window.location.href == window.location.origin + "/assessment") {
      try {
        Window["AssessmentPageReference"].ReadjustAngelValues(yaxis);
      } catch (e: any) {
        if (GetOSId() === ApplicationLookup.iOS) {
          console.log("ReadjustAngelValues error");
          return "";
        }
      }
    } else {
      if (GetOSId() === ApplicationLookup.iOS) {
        return "";
      }
      console.log(
        "Native Call for Angle Adjustment and didn't match with the route",
      );
    }
    return "";
  }

  //   function UpdateSliderOnMovement(yaxis: number, xaxis: number) {
  //     try {
  //         // Convert yaxis to number if it's not already a number
  //         yaxis = Number(yaxis);

  //         if (window.location.href == window.location.origin + "/angle-adjustment") {
  //             // Check if the object and method exist before calling them
  //             if (Window["AngleAdjustmentPageReference"] && Window["AngleAdjustmentPageReference"].UpdateSliderOnMovement) {
  //                 Window["AngleAdjustmentPageReference"].UpdateSliderOnMovement(yaxis);
  //             } else {
  //                 console.error("AngleAdjustmentPageReference or its method UpdateSliderOnMovement is not defined.");
  //             }
  //         } else if (window.location.href == window.location.origin + "/assessment") {
  //             // Check if the object and method exist before calling them
  //             if (Window["AssessmentPageReference"] && Window["AssessmentPageReference"].ReadjustAngelValues) {
  //                 Window["AssessmentPageReference"].ReadjustAngelValues(yaxis);
  //             } else {
  //                 console.error("AssessmentPageReference or its method ReadjustAngelValues is not defined.");
  //             }
  //         } else {
  //             console.log("Native Call for Angle Adjustment and didn't match with the route");
  //         }
  //     } catch (error) {
  //         console.error("An error occurred:", error);
  //     }

  //     return ""; // Ensure the function always returns a string
  // }
  function updateNetworkStatus() {
    debugger;
    if (
      !window.navigator.onLine &&
      window.location.href.includes("/assessment")
    ) {
      closeApp();
    } else if (
      window.navigator.onLine &&
      window.location.href.includes("/assessment")
    ) {
      window.location.href = window.location.origin + "/patient-page";
    }
    if (
      window.location.href.includes("/confirmation") &&
      window.navigator.onLine
    ) {
    }
    setShowNetWorkRecoil({
      isShown:
        !window.navigator.onLine && !window.location.href.includes("/login"),
    });
  }

  useEffect(() => {
    getMobileUIVersion();
    window.addEventListener("offline", () => {
      updateNetworkStatus();
    });
    window.addEventListener("online", () => {
      updateNetworkStatus();
    });
  }, []);

  useEffect(() => {
    if (showToast.show) {
      setTimeout(() => {
        setShowToast((prevState: any) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    }
  }, [showToast.show]);

  useEffect(() => {
    const token = localStorage.getItem("TokenID");
    const obj = {
      pendoKey: localStorage.getItem("pendoKey")!,
      workstationCode: localStorage.getItem("workstationCode")!,
      loggedInUserId: localStorage.getItem("loggedInUserId")!,
      email: localStorage.getItem("email")!,
      firstName: localStorage.getItem("firstName")!,
      lastName: localStorage.getItem("lastName")!,
      businessType: localStorage.getItem("businessType")!,
      businessCode: localStorage.getItem("businessCode")!,
      businessName: localStorage.getItem("businessName")!,
      locationName: localStorage.getItem("locationName")!,
    };
    if (token !== null && token !== undefined) {
      initializePendo(obj);
    }
  }, []);

  //pre-loading the DL models to speedup assessment page loading times
  useEffect(() => {
    if (!JSON.parse(sessionStorage.getItem("DLModel")! || "false")) {
      sessionStorage.setItem("DLModel", JSON.stringify(true));
      setLoadingDLModel(true);
      new Promise((resolve, reject) => {
        load_DL_models()
          .then(() => {
            setLoadingDLModel(false);
            resolve(true);
          })
          .catch((err) => {
            DL_MODELS.MessageForSentry =
              "Error in loading models. Error: " + err;
            console.log("Error in loading models", err);
            setLoadingDLModel(false);
            reject(err);
          });
      });
    }
  }, []);

  // const onPrompt = () => {
  //   // Fire a Modal Prompt
  //   let isTokenID = localStorage.getItem("TokenID") == null ? false : true;
  //   let isLoggedinUser = localStorage.getItem("isLogin") == null ? false : true;
  //   if (isLoggedinUser && isTokenID) {
  //     debugger;
  //     setShowPrompt(true);

  //     if (myTimeoutRef.current) {
  //       clearTimeout(myTimeoutRef.current);
  //     }

  //     myTimeoutRef.current = setTimeout(() => {
  //       setShowPrompt(false);
  //       LogOutUser();
  //     }, 60 * 1000);
  //   }
  // };

  const onPrompt = () => {
    // Fire a Modal Prompt
    // console.log('getRemainingTime : ', getRemainingTime());
    let isTokenID = localStorage.getItem("TokenID") == null ? false : true;
    let isLoggedinUser = localStorage.getItem("isLogin") == null ? false : true;
    if (isLoggedinUser && isTokenID) {
      debugger;
      setShowPrompt(true);
      let Timeout = setTimeout(function () {
        debugger;
        // console.log("Logging Out")
        setShowPrompt(false);
        LogOutUser();
        clearTimeout(myTimeout);
      }, 60 * 1000);
      setmyTimeout(Timeout);
    }
  };

  function LogOutUser() {
    LogOut().then(function (response) {
      if (response && response?.data.responseCode === 1) {
        pause();
        window.location.href = window.location.origin + "/login";
      } else {
        pause();
        setIsServerError(true);
      }
    });
  }

  const onIdle = () => {
    console.log("Idle.........", isLoggedIn);
  };

  const onAction = (event: any) => {
    if (isLoggedIn) {
      // lastActivityRef.current = Date.now();

      const remainingTime = getRemainingTime();
      if (remainingTime <= 0) {
        LogOutUser();
      }
    }
  };

  const { reset, pause, getRemainingTime } = useIdleTimer({
    onPrompt,
    onIdle,
    // onActive,
    onAction,
    timeout: 60 * 60 * 1000,
    promptTimeout: 60 * 1000,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });

  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("TokenID") == null
      ? false
      : true && localStorage.getItem("isLogin") == null
        ? false
        : true,
  ); //This is a temporary solution for testing the UI and NOT meant for production.
  const [showPrompt, setShowPrompt] = useState<boolean>(false);

  if (performance.navigation.type === 1) {
    sessionStorage.clear();
  }
  const networkPopup = () => {
    setShowNetWorkRecoil({
      isShown: false,
    });
  };

  //Removing previous ionic page reference
  useEffect(() => {
    const pages = document.querySelectorAll("ion-page");
    if (pages.length > 1) {
      pages[0].remove(); // Remove the previous page
    }
  }, [history]);

  if (!isLoggedIn) {
    return (
      <>
        {/* <Online> */}
        <IonApp className="balance-app">
          {loadingDLModel ? (
            <Loader />
          ) : (
            <>
              <IonModal
                backdropDismiss={false}
                isOpen={ShowNetWorkRecoil.isShown}
                placeholder={undefined}
                className="overall-center-modal-main-wrap"
              >
                <NetworkError setShouldShowNetWorkPopup={networkPopup} />
              </IonModal>
              <IonReactRouter>
                <IonRouterOutlet placeholder={undefined}>
                  <Route
                    exact
                    path="/login"
                    render={() => (
                      <Login
                        setIsLoggedIn={setIsLoggedIn}
                        updateNetworkStatus={updateNetworkStatus}
                      />
                    )}
                  />
                  <Route exact path="/">
                    <Redirect to="/login" />
                  </Route>
                  <Route exact path="/home">
                    <Redirect to="/login" />
                  </Route>
                </IonRouterOutlet>
                <Switch>
                  <Route
                    path="/password-reset"
                    component={(props: any) => (
                      <PasswordReset actionType={props.location.state} />
                    )}
                  />
                  <Route
                    path="/signup-password"
                    component={(props: any) => (
                      <SignupPassword actionType={props.location.state} />
                    )}
                  />
                  <Route
                    path="/email"
                    component={(props: any) => (
                      <ForgotPassword actionType={props.location.state} />
                    )}
                  />
                  <Route
                    path="/code"
                    component={(props: any) => (
                      <Code actionType={props.location.state} />
                    )}
                  />
                  <Route path="/signup" component={Signup} />
                  <Route
                    path="/confirmation"
                    component={(props: any) => (
                      <SuccessFailed actionType={props.location.state} />
                    )}
                  />
                  <Route path="/signup-email" component={SignupEmail} />
                  <Route path="/signup-code" component={SignupCode} />
                  <Route path="/signup" component={Signup} />
                  <Route path="/signup-password" component={SignupPassword} />
                </Switch>
              </IonReactRouter>
            </>
          )}
        </IonApp>
      </>
    );
  } else {
    return (
      <>
        <IonApp className="balance-app">
          {showToast.show && <ErrorTopToaster errorString={showToast.string} />}
          {isServerError && (
            <SuccessFailed actionType={ActionType.FailureAPIResponse} />
          )}

          {loadingDLModel ? (
            <Loader />
          ) : (
            <>
              <IonModal
                className="overall-center-modal-main-wrap"
                backdropDismiss={false}
                isOpen={showPrompt}
                placeholder={undefined}
              >
                <IonContent placeholder={undefined}>
                  {/* Start of Timeout Session Modal  */}
                  <div className="overall-center-modal">
                    <div className="generic-modal-main-wrap">
                      <div className="icon-sec text-center">
                        <div>
                          <svg
                            width="146"
                            height="129"
                            viewBox="0 0 146 129"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M109.361 128.841C118.972 128.841 128.189 125.024 134.984 118.228C141.78 111.432 145.598 102.215 145.598 92.6048C145.598 82.9942 141.78 73.7773 134.984 66.9816C128.189 60.1859 118.972 56.3682 109.361 56.3682C99.7506 56.3682 90.5337 60.1859 83.738 66.9816C76.9423 73.7773 73.1245 82.9942 73.1245 92.6048C73.1245 102.215 76.9423 111.432 83.738 118.228C90.5337 125.024 99.7506 128.841 109.361 128.841ZM113.387 76.4996V88.5785H121.44C123.654 88.5785 125.466 90.3903 125.466 92.6048C125.466 94.8193 123.654 96.6311 121.44 96.6311H109.361C107.147 96.6311 105.335 94.8193 105.335 92.6048V76.4996C105.335 74.2852 107.147 72.4733 109.361 72.4733C111.576 72.4733 113.387 74.2852 113.387 76.4996Z"
                              fill="#802392"
                            />
                            <path
                              opacity="0.4"
                              d="M0.651367 8.05258C0.651367 3.5985 4.24987 0 8.70395 0H16.7565H81.1772H89.2298C93.6839 0 97.2824 3.5985 97.2824 8.05258C97.2824 12.5067 93.6839 16.1052 89.2298 16.1052V18.8732C89.2298 29.5429 84.977 39.7848 77.4277 47.3341L60.3663 64.4207L69.4255 73.4798C66.6574 79.2676 65.0972 85.76 65.0972 92.6047C65.0972 107.577 72.5458 120.814 83.9201 128.841H81.1772H16.7565H8.70395C4.24987 128.841 0.651367 125.243 0.651367 120.789C0.651367 116.335 4.24987 112.736 8.70395 112.736V109.968C8.70395 99.2984 12.9567 89.0565 20.506 81.5072L37.5674 64.4207L20.506 47.3341C12.9567 39.7848 8.70395 29.5429 8.70395 18.8732V16.1052C4.24987 16.1052 0.651367 12.5067 0.651367 8.05258ZM24.8091 16.1052V18.8732C24.8091 23.6545 26.2183 28.2847 28.8354 32.2103H69.0983C71.6903 28.2847 73.1246 23.6545 73.1246 18.8732V16.1052H24.8091Z"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="generic-modal-text">
                        <h1>Time Out</h1>
                        <p>
                          Your session has timed out. Login again to continue.
                        </p>
                      </div>

                      <div className="generic-modal-btn-wrap two-btns">
                        <ul>
                          <li>
                            <IonButton
                              className="generic-btn generic-btn-outline"
                              placeholder={undefined}
                              onClick={() => {
                                // if (myTimeoutRef.current) {
                                //   clearTimeout(myTimeoutRef.current);
                                // }
                                clearTimeout(myTimeout);
                                setShowPrompt(false);
                                reset();
                              }}
                            >
                              I'm Here
                            </IonButton>
                          </li>

                          <li>
                            <IonButton
                              className="generic-btn"
                              placeholder={undefined}
                              onClick={() => {
                                LogOutUser();
                              }}
                            >
                              Login
                            </IonButton>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* End of Timeout Session Modal */}
                </IonContent>
              </IonModal>
              <IonModal
                backdropDismiss={false}
                isOpen={ShowNetWorkRecoil.isShown}
                placeholder={undefined}
                className="overall-center-modal-main-wrap"
              >
                <NetworkError setShouldShowNetWorkPopup={networkPopup} />
              </IonModal>
              <IonReactRouter>
                <IonRouterOutlet id="menu-content" placeholder={undefined}>
                  <Route
                    path="/patient-assessment-summary"
                    component={PatientAssessmentSummary}
                  />
                  <Route
                    path="/select-an-assessment"
                    component={SelectAnAssessment}
                  />
                  <Route
                    path="/assessment"
                    render={(props: any) => <AssessmentPage />}
                  />
                  <Route
                    path="/gait-assessment-info"
                    render={(props: any) => (
                      <GaitAssessmentInfo
                        assessmentType={props.location.state}
                      />
                    )}
                  />
                  <Route path="/assessment-notes" component={AssessmentNotes} />
                  <Route
                    path="/phone-audio-check"
                    component={PhoneAudioCheck}
                  />
                  <Route path="/equipment-needed" component={EquipmentNeeded} />
                  <Route
                    path="/phone-height-requirement"
                    component={PhoneHeightRequirement}
                  />
                  <Route
                    path="/angle-adjustment"
                    component={(props: any) => (
                      <AngleAdjustment
                        restartAdjustment={props.location.state}
                      />
                    )}
                  />
                  <Route
                    path="/sitStandAssessment"
                    render={(props: any) => <SitStandAssessmentPage />}
                  />
                  <Route
                    path="/select-assessment-type"
                    component={SelectAssessmentType}
                  />
                </IonRouterOutlet>
                <Switch>
                  <Route exact path="/">
                    <Redirect to="/home" />
                  </Route>
                  <Route
                    path="/confirmation"
                    component={(props: any) => (
                      <SuccessFailed actionType={props.location.state} />
                    )}
                  />

                  <Route exact path="/home" render={() => <Home />} />

                  <Route
                    exact
                    path="/user-profile"
                    render={(props: any) => (
                      <UserProfile props={props.location.state} />
                    )}
                  />
                  <Route
                    path="/edit-user-profile"
                    render={(props: any) => (
                      <EditUserProfile actionType={props.location.state} />
                    )}
                  />
                  <Route
                    path="/create-new-patient-2"
                    render={(props: any) => (
                      <CreateNewPatient props={props.location.state} />
                    )}
                  />
                  <Route
                    path="/create-edit-patient"
                    render={(props: any) => (
                      <CreateEditPatient props={props.location.state} />
                    )}
                  />
                  <Route path="/create-new-tag/" component={CreateNewLookup} />
                  <Route
                    exact
                    path="/patient-page"
                    render={(props: any) => (
                      <PatientPage props={props.location.state} />
                    )}
                  />
                  <Route path="/visit-summary" component={VisitSummary} />
                  <Route path="/end-session" component={EndSession} />
                  <Route
                    path="/full-visit-summary"
                    render={(props: any) => (
                      <FullVisitSummary patientInfo={props.location.state} />
                    )}
                  />
                  <Route
                    path="/duplicate-exercise"
                    render={(props: any) => (
                      <DuplicateExercises visitData={props.location.state} />
                    )}
                  />
                  <Route
                    path="/assign-exercise"
                    render={(props: any) => (
                      <AssignExercise
                        exercisesRecommendationHistory={props.location.state}
                      />
                    )}
                  />
                  <Route path="/review-exercises" component={ReviewExercises} />
                  <Route
                    path="/send-exercise-plan"
                    component={SendExercisePlan}
                  />
                  <Route path="/report-page" component={ReportPage} />
                  <Route path="/select-new" component={SelectSectionCustom} />
                  <Route path="/tags-name" component={TagsName} />
                  <Route path="/paper-error" component={PaperErrorPopup} />
                  <Route
                    path="/loader-calibrating"
                    component={LoaderModalComponent}
                  />
                  <Route
                    path="/paper-assessment"
                    component={PaperPlacementModal}
                  />
                  <Route
                    path="/assessment-description"
                    component={AssessmentDescription}
                  />
                  <Route path="/assessments-list" component={AssessmentsList} />
                  <Route
                    path="/assessment-info-table"
                    component={AssessmentInfoTable}
                  />
                  <Route
                    exact
                    path="/patient-profile"
                    render={(props: any) => (
                      <PatientProfile props={props.location.state} />
                    )}
                  />
                  <Route path="/about" component={About} />
                  <Route path="/termofservices" component={TermsOfServices} />
                  <Route path="/privacypolicy" component={PrivacyPolicy} />
                </Switch>
              </IonReactRouter>
            </>
          )}
        </IonApp>
      </>
    );
  }
};
export default App;
